// extracted by mini-css-extract-plugin
module.exports = {"component":"drawer-card-component--1f2vJ"};